import { takeLatest, call, put } from 'redux-saga/effects';
import Cookies from 'universal-cookie';
import api from '../../../utilities/api';
import * as actionCreators from './action-creators';
import { LOAD_FEATURE_FLAGS_DATA } from './actions';
import { FeatureFlagsStatus } from './constants';

export function* rootSaga() {
  yield takeLatest(LOAD_FEATURE_FLAGS_DATA, loadFeatureFlags);
}

export function* loadFeatureFlags() {
  try {
    yield put(actionCreators.setFeatureFlagsStatus(FeatureFlagsStatus.LOADING));
    const cookies = new Cookies();
    const token = cookies.get('LoginToken');
    const response = yield call(api.get, '/api/featureFlags', {
      headers: { Authorization: `Bearer ${token}` },
      timeout: 15000,
    });
    const data = response.data;
    const flags = data && data.Payload;
    if (!data || data.StatusCode !== 200 || !flags ||
        typeof flags.Promotions !== 'boolean' ||
        typeof flags.AdvancedBionics !== 'boolean') {
      throw new Error('Invalid feature settings response');
    }
    yield put(actionCreators.setFeatureFlagsData(flags));
    yield put(actionCreators.setFeatureFlagsStatus(FeatureFlagsStatus.SUCCESS));
  } catch (error) {
    yield put(actionCreators.setFeatureFlagsData(null));
    yield put(actionCreators.setFeatureFlagsStatus(FeatureFlagsStatus.ERROR));
  }
}
